export class ListLogSourcesPoliciesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "llgLocations",
            "baseName": "llgLocations",
            "type": "Array<LlgLocationWithResources>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListLogSourcesPoliciesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
